  (function () {
    class CollectionCustomSlider extends HTMLElement {
      constructor() {
        super();
        this.slider = null;
        this.resizeTimer = null;
      }

      connectedCallback() {
        this.slider = this.querySelector('.slider__collection-custom');

        if (!this.slider) return;

        this.init();

        window.addEventListener('resize', this.onResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        this.destroy();
      }

      onResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.reInit();
        }, 200);
      };

      getBoolAttr(name, fallback = false) {
        const value = this.getAttribute(name);
        if (value === null) return fallback;
        return value === 'true';
      }

      getNumAttr(name, fallback) {
        const value = this.getAttribute(name);
        return value !== null && !isNaN(value) ? Number(value) : fallback;
      }

      getSettings() {
        return {
          slidesToShow: this.getNumAttr('data-desktop', 4),
          slidesToScroll: this.getNumAttr('data-scroll-desktop', 1),
          autoplay: this.getBoolAttr('data-autoplay', false),
          autoplaySpeed: this.getNumAttr('data-autoplay-speed', 3000),
          arrows: this.getBoolAttr('data-arrows', true),
          dots: this.getBoolAttr('data-dots', false),
          infinite: this.getBoolAttr('data-infinite', false),
          centerMode: this.getBoolAttr('data-center-mode', false),
          centerPadding: this.getAttribute('data-center-padding') || '0px',
          speed: this.getNumAttr('data-speed', 300),
          rows: this.getNumAttr('data-rows', 1),
          rtl: this.getBoolAttr('data-rtl', false),
          adaptiveHeight: this.getBoolAttr('data-adaptive-height', false),
          variableWidth: this.getBoolAttr('data-variable-width', false),
          mobileFirst: this.getBoolAttr('data-mobile-first', false),
          prevArrow:
            this.querySelector('.slider-custom-prev') ||
            '<button type="button" class="slick-prev">Previous</button>',
          nextArrow:
            this.querySelector('.slider-custom-next') ||
            '<button type="button" class="slick-next">Next</button>',
          responsive: [
            {
              breakpoint: 990,
              settings: {
                slidesToShow: this.getNumAttr('data-tablet', 2),
                slidesToScroll: this.getNumAttr('data-scroll-tablet', 1)
              }
            },
            {
              breakpoint: 750,
              settings: {
                slidesToShow: this.getNumAttr('data-mobile', 1),
                slidesToScroll: this.getNumAttr('data-scroll-mobile', 1)
              }
            }
          ]
        };
      }

      init() {
        if (!this.slider || typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
          return;
        }

        const $slider = jQuery(this.slider);

        if ($slider.hasClass('slick-initialized')) return;

        const settings = this.getSettings();
        $slider.slick(settings);
      }

      destroy() {
        if (!this.slider || typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
          return;
        }

        const $slider = jQuery(this.slider);

        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }

      reInit() {
        this.destroy();
        this.init();
      }
    }

    if (!customElements.get('collection-custom-slider')) {
      customElements.define('collection-custom-slider', CollectionCustomSlider);
    }
  })();


// tab-collections tab-collections__slider
document.querySelectorAll('.tab-collections__panel').forEach((wrapper) => {
  collectionTabSlider(wrapper);
});


function collectionTabSlider(wrapper){
  const slider = wrapper.querySelector('.tab-collections__slider');
  const slides = parseInt(slider.getAttribute('data-slides')) || 4;
  const loop = slider.getAttribute('data-loop') === 'true';
  const autoplayDelay = parseInt(slider.getAttribute('data-autoplay'));
  const paginationEnabled = slider.getAttribute('data-pagination') === 'true';
  const navigationEnabled = slider.getAttribute('data-navigation') === 'true';
  const sectionId = slider.getAttribute('data-section') || "";
  const mobileSlide = parseInt( slider.getAttribute('data-mobile-slide') ) || 1 ;
  const tablateSlide = parseInt( slider.getAttribute('data-tablet-slide') ) || 2 ;


    new Swiper(slider, {
      slidesPerView: slides,
      loop: loop,
      spaceBetween: 20,

      pagination: paginationEnabled ? {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      } : false,

      
      navigation: {
        nextEl: wrapper.querySelector(`.custom-next-${sectionId}`),
        prevEl: wrapper.querySelector(`.custom-prev-${sectionId}`),
      },

      breakpoints: {
        320: { slidesPerView: mobileSlide },
        768: { slidesPerView: tablateSlide },
        1024: { slidesPerView: slides }
      }
    });
}
document.querySelectorAll('.tab-collections').forEach((wrapper) => {

  const tabs = wrapper.querySelectorAll('.tab-collections__tab');
  const panels = wrapper.querySelectorAll('.tab-collections__panel');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {

      const target = tab.dataset.tab;


      tabs.forEach(t => t.classList.remove('active'));
      panels.forEach(p => p.classList.remove('active'));

      tab.classList.add('active');

      const activePanel = wrapper.querySelector(`.tab-collections__panel[data-panel="${target}"]`);
      activePanel.classList.add('active');

console.log(activePanel);
      // const swiperEl = activePanel.querySelector('.tab-collections__slider');

          setTimeout(function(){
      collectionTabSlider(activePanel);
      },500);

    });
  });

});